import { api } from "api";
import useAsyncFn from "react-use/lib/useAsyncFn";
import { createPublicClient, erc20Abi, http } from "viem";
import { useAccount } from "wagmi";
import { useUnpausedForkStatus } from "../context";

export default function useDegenNFTFaucet() {
  const { executionId, rpcUrl } = useUnpausedForkStatus();
  const { address: account } = useAccount();

  return useAsyncFn(async () => {
    if (account) {
      // assume that there's only one degen nft
      const {
        donations: [{ degenNFT }],
      } = await api.requestDegenNft(executionId, account, 10);

      const balance = await createPublicClient({
        transport: http(rpcUrl),
      }).readContract({
        abi: erc20Abi,
        address: degenNFT,
        functionName: "balanceOf",
        args: [account],
      });
      return balance;
    }
  }, [account, executionId, rpcUrl]);
}
